var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-flex gl-break-anywhere"},[_c('span',{staticClass:"dropdown-label-box gl-top-0 gl-mr-3 gl-shrink-0",style:({ 'background-color': _vm.label.color }),attrs:{"data-testid":"label-color-box"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.label.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }